import { DefaultError, useMutation } from "@tanstack/react-query";
import { bulkCreateModulesByBrandPage } from "../api/bulkCreateModulesByBrandPage";
import { bulkUpdateModulesByBrandPage } from "../api/bulkUpdateModulesByBrandPage";
import { getModuleListByBranchPageQueryData } from "../queries/useModuleListByBrandPageQuery";
import { PageModuleDataToInsert } from "../types";

type Params = {
  brandId: string;
  pageId: string;
  batchData: PageModuleDataToInsert[];
  onSuccess?: () => void;
};

export const useCreateModuleBatchMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      const prevData = getModuleListByBranchPageQueryData(
        params.brandId,
        params.pageId,
      );

      // we assume that modules batch will be created at the top of the list
      //  with correct orders, so we are just incrementing it

      const batchDataToUpdate =
        prevData?.reduce((acc, moduleData) => {
          return {
            ...acc,
            [moduleData.id]: {
              order: moduleData.order + params.batchData.length,
            },
          };
        }, {}) ?? {};

      const shouldBulkUpdate = !!Object.keys(batchDataToUpdate).length;

      await Promise.all([
        bulkCreateModulesByBrandPage(
          params.brandId,
          params.pageId,
          params.batchData,
        ),
        shouldBulkUpdate &&
          bulkUpdateModulesByBrandPage(
            params.brandId,
            params.pageId,
            batchDataToUpdate,
          ),
      ]);
    },
    onSuccess: (_, params) => {
      params.onSuccess?.();
    },
    onError: (e) => {
      console.error("Error occurred when creating batch of modules", e);
    },
  });
};
